export function getCollapsibleStyles(props) {
    const { theme } = props;
    const { effects } = theme;
    const styles = {
        root: {
            borderTop: 'unset',
            '::before': [
                {
                    backgroundColor: theme.palette?.neutralQuaternaryAlt,
                    height: '2px',
                    display: 'flex',
                    borderRadius: effects?.roundedCorner2,
                    content: '""',
                },
            ],
        },
    };
    return styles;
}
//# sourceMappingURL=Collapsible.styles.js.map